
import {createContext, useState} from 'react'

const Context = createContext()

export const UserContextProvider = ({children}) => {
 const [allUsers, setAllUsers] = useState([])
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allUsers, setAllUsers, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context